'use client';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useState } from 'react';
import style from './style.module.css';

const AccordionCard = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={style.containerAccordion}>
      <div className={style.accordionHeader} onClick={toggleAccordion}>
        <span className={style.title}>{title}</span>
        {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </div>
      {isOpen && <div>{children}</div>}
    </div>
  );
};

export default AccordionCard;
